// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetPairTicker (params?: {}): Promise<Dict>;
    publicGetTickers (params?: {}): Promise<Dict>;
    publicGetTickersJpy (params?: {}): Promise<Dict>;
    publicGetPairDepth (params?: {}): Promise<Dict>;
    publicGetPairTransactions (params?: {}): Promise<Dict>;
    publicGetPairTransactionsYyyymmdd (params?: {}): Promise<Dict>;
    publicGetPairCandlestickCandletypeYyyymmdd (params?: {}): Promise<Dict>;
    publicGetPairCircuitBreakInfo (params?: {}): Promise<Dict>;
    privateGetUserAssets (params?: {}): Promise<Dict>;
    privateGetUserSpotOrder (params?: {}): Promise<Dict>;
    privateGetUserSpotActiveOrders (params?: {}): Promise<Dict>;
    privateGetUserMarginStatus (params?: {}): Promise<Dict>;
    privateGetUserMarginPositions (params?: {}): Promise<Dict>;
    privateGetUserSpotTradeHistory (params?: {}): Promise<Dict>;
    privateGetUserDepositHistory (params?: {}): Promise<Dict>;
    privateGetUserUnconfirmedDeposits (params?: {}): Promise<Dict>;
    privateGetUserDepositOriginators (params?: {}): Promise<Dict>;
    privateGetUserWithdrawalAccount (params?: {}): Promise<Dict>;
    privateGetUserWithdrawalHistory (params?: {}): Promise<Dict>;
    privateGetSpotStatus (params?: {}): Promise<Dict>;
    privateGetSpotPairs (params?: {}): Promise<Dict>;
    privatePostUserSpotOrder (params?: {}): Promise<Dict>;
    privatePostUserSpotCancelOrder (params?: {}): Promise<Dict>;
    privatePostUserSpotCancelOrders (params?: {}): Promise<Dict>;
    privatePostUserSpotOrdersInfo (params?: {}): Promise<Dict>;
    privatePostUserConfirmDeposits (params?: {}): Promise<Dict>;
    privatePostUserConfirmDepositsAll (params?: {}): Promise<Dict>;
    privatePostUserRequestWithdrawal (params?: {}): Promise<Dict>;
    marketsGetSpotPairs (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
